﻿import React from "react";
import PropTypes from "prop-types";
import "./StatusBox.css";

const WorkflowMapStatus = {
  SUCCESSFUL: "Successful",
  PROCESSING: "Processing",
  ERROR: "Error",
  NOT_QUEUED: "Not Queued",
};

const statusBoxWidth = 40;
const offSetFromArtifact = 25;
const statusBoxGap = 9;
const totalStatusBoxLength =
  offSetFromArtifact * 2 + statusBoxWidth * 4 + statusBoxGap * 3;

const StatusBox = ({ statuses, direction, x, y, workflowState }) => {
  const getStatusClass = (status) => {
    switch (status) {
      case WorkflowMapStatus.SUCCESSFUL:
        return "workflow-status-successful";
      case WorkflowMapStatus.PROCESSING:
        return "workflow-status-processing";
      case WorkflowMapStatus.ERROR:
        return "workflow-status-error";
      case WorkflowMapStatus.NOT_QUEUED:
        return "workflow-status-not-queued";
      default:
        return "workflow-status-default";
    }
  };

  const truncateCount = (count) => {
    const num = parseInt(count, 10);
    if (isNaN(num)) return count;
    if (num >= 1e15) return `${Math.floor(num / 1e15)}Q`;
    if (num >= 1e12) return `${Math.floor(num / 1e12)}T`;
    if (num >= 1e9) return `${Math.floor(num / 1e9)}B`;
    if (num >= 1e6) return `${Math.floor(num / 1e6)}M`;
    if (num >= 1e3) return `${Math.floor(num / 1e3)}K`;
    return count;
  };

  const orderedStatuses =
    direction === "vertical" ? [...statuses].reverse() : statuses; //vertical statusboxes are bottom to top, requires reversing

    return (
    <div
      className={`workflow-status-box ${direction}`}
      style={{
        left: `${x}px`,
        top: `${y}px`,
        position: "absolute",
      }}
    >
      {orderedStatuses.map(
        ({ status, count }) =>
          count !== 0 && (
            <div
              key={status}
              className={`workflow-status ${getStatusClass(
                status
              )} ${workflowState}`}
            >
              {truncateCount(count)}
            </div>
          )
      )}
    </div>
  );
};

StatusBox.propTypes = {
  statuses: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.oneOf(Object.values(WorkflowMapStatus)).isRequired,
      count: PropTypes.number.isRequired,
    })
  ).isRequired,
  direction: PropTypes.oneOf(["horizontal", "vertical"]).isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  workflowState: PropTypes.string.isRequired,
};

StatusBox.defaultProps = {
  direction: "horizontal",
};

export default StatusBox;
export {
  WorkflowMapStatus,
  statusBoxWidth,
  offSetFromArtifact,
  statusBoxGap,
  totalStatusBoxLength,
};
